import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomAvatar, CustomButton, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { BLOCK, COPY, LOGOUT, MESSAGE } from "../../assets/icons";
import InfoBaraTable from "./component/InfoBaraTable";
import BlocageBossTable from "./component/BlocageBossTable";
import ParticulariteBossTable from "./component/ParticulariteBossTable";
import { useEffect, useState } from "react";
import { batch, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getAsyncBoss } from "../../store/features/bossSlice";
import { listAsyncOffreByBoss } from "../../store/features/offreSlice";

function BossProfile() {
  const [data, setData] = useState(null) as any;
  const [baraData, setBaraData] = useState([]) as any;
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id || "";

  const callback = (item: any) => {
    setData(item);
  };

  const callbackBara = (item: any) => {
    setBaraData(item);
  };

  const getData = () => {
    batch(() => {
      dispatch(getAsyncBoss(id, callback) as any);
      dispatch(listAsyncOffreByBoss(id, callbackBara) as any);
    });
  };

  // console.log(data);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Grid container>
        <Grid item xs={7}>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              p: 2,
              py: 3,
              px: 5,
              width: 550,
              boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
            }}
          >
            <Stack sx={{ alignItems: "center" }}>
              <CustomAvatar
                rootStyle={{
                  borderRadius: 100,
                  maxWidth: 135,
                  maxHeight: 135,
                  marginTop: 0,
                  padding: 0,
                  marginBottom: 2,
                }}
                avatarStyle={{ borderRadius: 100, width: 120, height: 120 }}
              />

              <Typography my={1} fontWeight={550}>
                {`${data?.nom} ${data?.prenom}`}
              </Typography>
              <Stack direction={"row"} alignItems="center">
                <Typography fontSize={12} mr={1} color={theme.colors.primary}>
                  {`${data?.nom} ${data?.prenom}`}
                </Typography>
                <SvgContainer
                  svg={COPY}
                  color={theme.colors.primary}
                  width={15}
                />
              </Stack>
              <Typography fontSize={11} color="#3D423F" mb={2}>
                Crée le {new Date(data?.dateCreation).toLocaleDateString()}
              </Typography>

              <CustomButton
                title="Message"
                leftComponent={
                  <SvgContainer svg={MESSAGE} color={theme.colors.white} />
                }
                titleStyle={{ marginLeft: 1 }}
              />
            </Stack>
            <Divider orientation="vertical" flexItem />
            <Box>
              <Typography fontSize={20} mb={2} fontWeight={550}>
                {i18n.t("informations_basique")}
              </Typography>
              <Typography color="#9BA69C" fontSize={12}>
                Email
              </Typography>
              <Stack direction={"row"} alignItems="center">
                <Typography fontSize={12} mr={1}>
                  {data?.email}
                </Typography>
                <SvgContainer
                  svg={COPY}
                  color={theme.colors.dimgray}
                  width={15}
                />
              </Stack>
              <CustomButton
                title={i18n.t("verifier")}
                titleStyle={{ color: theme.colors.primary, fontSize: 12 }}
                rootStyle={{ backgroundColor: "transparent", paddingLeft: 0 }}
              />
              <Divider sx={{ my: 2 }} />
              <Typography color="#9BA69C" fontSize={12}>
                {i18n.t("localisation")}
              </Typography>
              <Typography fontSize={12}>{data?.adresse}</Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={5}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              p: 2,
              py: 3,
              px: 5,
              width: 400,
              boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
            }}
          >
            <Typography fontSize={20} mb={2} fontWeight={550}>
              {i18n.t("informations_financieres")}
            </Typography>
            <Stack
              sx={{
                borderLeft: "10px solid #00833D",
                height: 230,
                justifyContent: "space-between",
                pl: 2,
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
              }}
            >
              <Box>
                <Stack direction={"row"} alignItems={"center"} spacing={2}>
                  <Typography
                    color={"#9BA69C"}
                    fontSize={12}
                    sx={{ width: 100 }}
                  >
                    {i18n.t("points_fidelite")}
                  </Typography>
                  <CustomButton
                    disabled
                    title={data?.pointsDeFidelites + " pts"}
                    titleStyle={{ color: "#3D423F", fontSize: 12 }}
                    rootStyle={{
                      paddingLeft: 3,
                      paddingRight: 3,
                      backgroundColor: "#C2E9C6",
                    }}
                  />
                </Stack>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  spacing={2}
                  mt={4}
                >
                  <Typography
                    color={"#9BA69C"}
                    fontSize={12}
                    sx={{ width: 100 }}
                  >
                    {i18n.t("credit")}
                  </Typography>
                  <CustomButton
                    disabled
                    title={data?.credit + " FCFA"}
                    titleStyle={{ color: "#3D423F", fontSize: 12 }}
                    rootStyle={{
                      paddingLeft: 3,
                      paddingRight: 3,
                      backgroundColor: "#C2E9C6",
                    }}
                  />
                </Stack>
              </Box>
              <Stack direction={"row"} alignItems={"center"} spacing={2}>
                <CustomButton
                  title={i18n.t("crediter")}
                  rootStyle={{ paddingLeft: 5, paddingRight: 5 }}
                />
                <CustomButton
                  title={i18n.t("debiter")}
                  rootStyle={{ paddingLeft: 5, paddingRight: 5 }}
                />
              </Stack>
            </Stack>
          </Box>
        </Grid>
      </Grid>

      <Typography fontSize={20} fontWeight={550} mt={3} mb={2}>
        {i18n.t("informations_bara")}
      </Typography>

      <InfoBaraTable data={baraData} />

      <Typography fontSize={20} fontWeight={550} mt={3} mb={2}>
        {i18n.t("historique_blocage_deblocage")}
      </Typography>

      <BlocageBossTable data={[]} />

      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent="space-between"
        my={5}
      >
        <CustomButton
          title={i18n.t("deconnecter_user")}
          leftComponent={
            <SvgContainer svg={LOGOUT} color={theme.colors.white} width={15} />
          }
          titleStyle={{ marginLeft: 1 }}
          rootStyle={{ height: 40, backgroundColor: theme.colors.secondary }}
        />
        <CustomButton
          title={i18n.t("bloquer")}
          leftComponent={
            <SvgContainer svg={BLOCK} color={theme.colors.white} width={15} />
          }
          titleStyle={{ marginLeft: 1 }}
          rootStyle={{ height: 40, backgroundColor: "#FF8888" }}
        />
      </Stack>

      <Typography fontSize={20} fontWeight={550} mt={3} mb={2}>
        {i18n.t("particularite_boss")}
      </Typography>

      <ParticulariteBossTable data={[]} />
    </Box>
  );
}

export default BossProfile;
